import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import CookiesPage from "./pages/CookiesPage";
import ApiInfoPage from "./pages/ApiInfoPage";
import ProfilesPage from "./pages/ProfilesPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth helpers
export const getToken = () => localStorage.getItem("cb_token");
export const setToken = (token) => localStorage.setItem("cb_token", token);
export const removeToken = () => localStorage.removeItem("cb_token");
export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  try {
    const data = JSON.parse(token);
    return data.exp > Date.now() / 1000;
  } catch {
    return false;
  }
};

// Axios interceptor
axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              border: "1px solid #222222",
              color: "#EDEDED",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/cookies"
            element={
              <ProtectedRoute>
                <CookiesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perfis"
            element={
              <ProtectedRoute>
                <ProfilesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/documentacao"
            element={
              <ProtectedRoute>
                <ApiInfoPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/perfis" replace />} />
          <Route path="*" element={<Navigate to="/perfis" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
